import React, { useEffect, useMemo, useState } from 'react';
import { Radio, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import SellerAutocomplete from 'components/Tvendo/Common/SellerAutocomplete';
import { wsGetAll, wsPost, wsRemove } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';
import Modal from 'components/Tvendo/Common/ModalBase';
import { Add, Clear, Save } from '@material-ui/icons';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

function ReplaceSellerModal(props) {
  const { month, model, setOpen, showNotify } = props;
  const [data, setData] = useState([]);
  const [newData, setNewData] = useState();
  const [sellers, setSellers] = useState([]);
  const [toSellers, setToSellers] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [toSellerData, setToSellerData] = useState();
  const [fromSellerData, setFromSellerData] = useState();

  const [radioChecked, setRadioChecked] = useState();

  const [disabledToRadio, disabledFromRadio] = useMemo(() => {
    let disabledTo =
      toSellerData === undefined
        ? true
        : !(
            toSellerData?.customerPortfolioBureaus?.length > 0 &&
            toSellerData?.customerPortfolioBureaus[0]?.bureau?.description
          );

    let disabledFrom =
      fromSellerData === undefined
        ? true
        : !(
            fromSellerData?.customerPortfolioBureaus?.length > 0 &&
            fromSellerData?.customerPortfolioBureaus[0]?.bureau?.description
          );

    if (
      toSellerData?.customerPortfolioBureaus?.length > 0 &&
      toSellerData?.customerPortfolioBureaus[0]?.bureau?.description &&
      fromSellerData?.customerPortfolioBureaus?.length > 0 &&
      fromSellerData?.customerPortfolioBureaus[0]?.bureau?.description
    ) {
      return [false, false];
    }

    return [disabledTo, disabledFrom];
  }, [toSellerData, fromSellerData]);

  async function getSellerData(seller) {
    setRadioChecked(undefined);
    setLoadingData(true);
    let res = await wsGetAll(`base/seller/${seller.id}`);
    setLoadingData(false);
    if (res.success) {
      setToSellerData(res.data);
    }
  }

  async function getFromSellerData(seller) {
    setRadioChecked(undefined);
    setLoadingData(true);
    let res = await wsGetAll(`base/seller/${seller.id}`);
    setLoadingData(false);
    if (res.success) {
      setFromSellerData(res.data);
    }
  }

  async function getSellers() {
    let res = await wsGetAll(`base/seller?with_trashed=Y`);
    if (res.success) {
      setSellers(res.data);
      setToSellers(res.data.filter((seller) => seller.deleted_at === null));
    }
  }

  async function deleteRow(row) {
    setProcessing(true);
    let res = await wsRemove(`quota/seller-replacement/${row.id}`);
    if (res.success) {
      showNotify(res.message);
      await getData();
    } else {
      showNotify(res.message, 'error');
    }
    setProcessing(false);
  }

  async function getData() {
    let period = month.replace('-', '');
    let res = await wsGetAll(`quota/seller-replacement?period=${period}`);
    if (res.success) {
      setData(res.data);
    }
  }

  async function saveNewData() {
    if (newData.from_seller_id === undefined || newData.to_seller_id === undefined) {
      return showNotify('Seleccione todos los campos', 'info');
    }
    setProcessing(true);
    let period = month.replace('-', '');
    let base_bureau_id = null;
    if(radioChecked === 'TO'){
      if (toSellerData?.customerPortfolioBureaus?.length > 0) {
        base_bureau_id = toSellerData?.customerPortfolioBureaus[0]?.bureau?.id;
      }
    }
    if(radioChecked === 'FROM'){
      if (fromSellerData?.customerPortfolioBureaus?.length > 0) {
        base_bureau_id = fromSellerData?.customerPortfolioBureaus[0]?.bureau?.id;
      }
    }
    let res = await wsPost('quota/seller-replacement', {
      period,
      ...newData,
      base_bureau_id,
    });
    if (res.success) {
      showNotify(res.message);
      setNewData(undefined);
      await getData();
    } else {
      showNotify(res.message, 'error');
    }
    setProcessing(false);
  }

  useEffect(() => {
    getData();
  }, [month]);

  useEffect(() => {
    getSellers();
  }, []);

  return (
    <Modal
      title={`Reemplazo de vendedores periodo ${month}`}
      model={model}
      setOpen={() => {
        setOpen({ open: false });
      }}
      hideSave
      fullWidth
      maxWidth="md"
      entity=""
    >
      <RegularButton
        justIcon
        color="success"
        onClick={() => setNewData({})}
        disabled={newData !== undefined}
      >
        <Add />
      </RegularButton>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell width="50%">Vendedor A Reemplazar</TableCell>
            <TableCell width="50%">Reemplazo</TableCell>
            <TableCell width="2">Info</TableCell>
            <TableCell width="1">Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{row.from_seller.SlpName}</TableCell>
                <TableCell>{row.to_seller.SlpName}</TableCell>
                <TableCell>
                  <span style={{ width: '100px' }}>{row.bureau?.description}</span>
                </TableCell>
                <TableCell>
                  <RegularButton
                    justIcon
                    simple
                    round
                    color="danger"
                    disabled={processing}
                    onClick={() => deleteRow(row)}
                  >
                    <Clear />
                  </RegularButton>
                </TableCell>
              </TableRow>
            );
          })}
          {newData !== undefined && sellers.length > 0 && (
            <TableRow>
              <TableCell>
                <GridContainer>
                  <GridItem xs={12}>
                    <GridContainer>
                      <GridItem xs={10}>
                        {loadingData
                          ? 'Cargando...'
                          : toSellerData !== undefined && (
                              <>
                                <span style={{ width: '100px' }}>
                                  Cartera:{' '}
                                  {toSellerData?.customerPortfolio?.description || 'No definido'}
                                </span>
                                <br />
                                <span style={{ width: '100px' }}>
                                  Mesa:{' '}
                                  {(toSellerData?.customerPortfolioBureaus?.length > 0 &&
                                    toSellerData?.customerPortfolioBureaus[0]?.bureau
                                      ?.description) ||
                                    'No definido'}
                                </span>
                              </>
                            )}
                      </GridItem>
                      <GridItem xs={2}>
                        <Radio
                          disabled={disabledToRadio}
                          checked={radioChecked === 'TO'}
                          onClick={() => setRadioChecked('TO')}
                        />
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                  <GridItem xs={12}>
                    <SellerAutocomplete
                      sellers={sellers}
                      onChange={(_, item) => {
                        setNewData((data) => ({ ...data, from_seller_id: item?.id }));
                        getSellerData(item);
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </TableCell>
              <TableCell>
                <GridContainer>
                  <GridItem xs={12}>
                    <GridContainer>
                      <GridItem xs={10}>
                        {loadingData
                          ? 'Cargando...'
                          : fromSellerData !== undefined && (
                              <>
                                <span style={{ width: '100px' }}>
                                  Cartera:{' '}
                                  {fromSellerData?.customerPortfolio?.description || 'No definido'}
                                </span>
                                <br />
                                <span style={{ width: '100px' }}>
                                  Mesa:{' '}
                                  {(fromSellerData?.customerPortfolioBureaus?.length > 0 &&
                                    fromSellerData?.customerPortfolioBureaus[0]?.bureau
                                      ?.description) ||
                                    'No definido'}
                                </span>
                              </>
                            )}
                      </GridItem>
                      <GridItem xs={2}>
                        <Radio
                          disabled={disabledFromRadio}
                          checked={radioChecked === 'FROM'}
                          onClick={() => setRadioChecked('FROM')}
                        />
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                  <GridItem xs={12}>
                    <SellerAutocomplete
                      sellers={toSellers}
                      disabled={loadingData || !newData.from_seller_id}
                      onChange={(_, item) => {
                        setNewData((data) => ({
                          ...data,
                          to_seller_id: item?.id,
                        }));
                        getFromSellerData(item);
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </TableCell>
              <TableCell></TableCell>
              <TableCell>
                <div style={{ width: '90px' }}>
                  <RegularButton
                    justIcon
                    simple
                    round
                    color="success"
                    onClick={saveNewData}
                    disabled={processing}
                  >
                    <Save />
                  </RegularButton>
                  <RegularButton
                    justIcon
                    simple
                    round
                    color="danger"
                    disabled={processing}
                    onClick={() => setNewData(undefined)}
                  >
                    <Clear />
                  </RegularButton>
                </div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Modal>
  );
}

export default ReplaceSellerModal;
